import BootstrapField from '../utility/BootstrapField';
import LaneClosureRequestPresetLane from '../models/LaneClosureRequestPresetLane';
import LaneClosureRequestPresetRestriction from '../models/LaneClosureRequestPresetRestriction';
import LaneClosureRequestPresetSidewalk from '../models/LaneClosureRequestPresetSidewalk';
import LaneClosureRequestPresetBicycle from '../models/LaneClosureRequestPresetBicycle';


export default class LaneClosureRequestBlock {
	constructor(data) {
		if (!data) {
			data = {};
		}
		if (data.useTestData) {
			data = {}

		}

		Object.assign(this, {
			blockId: data.blockId || null,
			lanesClosedSameTime: new BootstrapField({
				value: data.lanesClosedSameTime || 'N/A',
				required: true,
			}),
			trafficSignalsAltered: new BootstrapField({
				value: typeof data.trafficSignalsAltered === 'number' ? data.trafficSignalsAltered : null,
			}),
			bicycle: [],
			sidewalk: [],
			// each lane entry contains: lane_id, lane_name, peakId, peakReason
			lane: [],
			// list of LCR restrictions
			// each restriction contains:  direction, type of restriction, cross street name, restrictionPeakId, peakReason
			restriction: [],

		});

		if (data.lane instanceof Array) {
			let x = 0;
			for (x = 0; x < data.lane.length; x++) {
				this.lane.push(new LaneClosureRequestPresetLane(data.lane[x]));
			}
		}


		if (data.sidewalk instanceof Array) {
			let x = 0;
			for (x = 0; x < data.sidewalk.length; x++) {
				this.sidewalk.push(new LaneClosureRequestPresetSidewalk(data.sidewalk[x]));
			}
		}

		if (data.bicycle instanceof Array) {
			let x = 0;
			for (x = 0; x < data.bicycle.length; x++) {
				this.bicycle.push(new LaneClosureRequestPresetBicycle(data.bicycle[x]));
			}
		}

		if (data.restriction instanceof Array) {
			let x = 0;
			for (x = 0; x < data.restriction.length; x++) {
				this.restriction.push(new LaneClosureRequestPresetRestriction(data.restriction[x]));
			}
		}


		// Keep a record of the old data. (used for the hasChanges() method)
		// originalLaneClosureBlockData = CloneDeep(this);
	}

	validate() {

		let flag = true;
		let errors = [];
		for (let field in this) {
			if (this[field] instanceof BootstrapField) {
				let result = this[field].validate();
				if (result === false) {
					errors.push(field);
					flag = false;
				}
			} else {
				if (Array.isArray(this[field])) {
					for (var x = 0; x < this[field].length; x++) {
						if (typeof this[field][x] == "object") {
							let result = this[field][x].validate();
							if (result === false) {
								flag = false;
							}
						}
					}
				}
			}
		}
		return flag;
	}

	getRawValue() {
		return getRawValue(this);

		function getRawValue(obj) {
			let value = {};

			if (obj instanceof BootstrapField) {
				value = obj.getRawValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getRawValue(obj[key][arrKey]));
						}
					} else {
						value[key] = getRawValue(obj[key]);
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}

	getValue() {
		return getValue(this);

		function getValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getValue(obj[key][arrKey]));
						}
					} else {
						value[key] = getValue(obj[key]);
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}


	hasChanges() {
		// var differences = DeepDiff.diff(originalLaneClosureBlockData.getRawValue(),  this.getRawValue());
		// return !IsEqual(originalLaneClosureBlockData.getRawValue(), this.getRawValue());
		return false;
	}
	revertChanges() {
		// this.constructor(originalLaneClosureBlockData);
	}
	saveChanges() {
		// originalLaneClosureBlockData = CloneDeep(this);
	}
}